import config from 'config/config.json';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export const canRunSentry = () =>
  Boolean(config.SENTRY_DSN) && typeof Sentry !== 'undefined';

export const initSentry = () => {
  if (canRunSentry()) {
    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: config.APP_ENV,
      integrations: [new BrowserTracing()],
    });
  }
};

export const captureException = (
  error = new Error('Capture Exception Error'),
) => {
  if (canRunSentry()) {
    Sentry.captureException(error);
  }
};
